import { SplashScreen } from '@capacitor/splash-screen';
import { useLayoutEffect } from 'react';

import { DEVICE } from '../../../config';

const CapacitorSplashScreenAutoHide = ['ANDROID', 'IOS'].includes(DEVICE) ? () => {
  useLayoutEffect(() => {
    try {
      console.log('📱 Splash screen hide');
      SplashScreen?.hide();
    } catch (err) {
      console.log(err);
    }
  }, []);
} : () => null;

export default CapacitorSplashScreenAutoHide;